import { handleGTMMsg } from '../../helpers';
import { actions as LOGOUT_ACTIONS } from '../../ducks/logout';
const logoutMap = {
    [LOGOUT_ACTIONS.SUCCESS.toString()]: (state, action) => handleGTMMsg({
        event: 'logout',
        login_status: 'logged-out',
        language: action.payload,
    }),
};
export default logoutMap;
